import Flex from './Flex';
import FlexItem from './FlexItem';
Flex.Item = FlexItem;
export default Flex;



// WEBPACK FOOTER //
// ./components/flex/index.tsx